export const downloadCSV = (csvContent: string, fileName: string) => {
  const linkSource = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent).replaceAll('#', '%23')
  const downloadLink = document.createElement('a')

  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.target = '_blank'
  downloadLink.click()
}

export const downloadExcel = (content: any, fileName: string) => {
  const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${content}`
  const downloadLink = document.createElement('a')

  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.target = '_blank'
  downloadLink.click()
}

const base64ToBlob = async (base64: string) => {
  const binaryString = window.atob(base64)
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; ++i) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return new Blob([bytes], { type: 'application/pdf' })
}

export const downloadLink = async (documentUrl: string, fileName: string) => {
  if (documentUrl) {
    var file = await base64ToBlob(documentUrl)
    if (file) {
      const nav = window.navigator as any
      if (nav && nav!.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(file, `${fileName}.pdf`)
      } else {
        var fileURL = URL.createObjectURL(file)
        window.open(fileURL, '_blank')
      }
    }
  }
}
